import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AppState } from 'src/redux/modules';
import { AlternativeProjectResource } from 'src/helpers/api/alternativeProjects';
import { loadAvatars as loadAvatarImages } from 'src/redux/modules/avatars';
import AlternativeProjects from 'src/components/AlternativeProjects';
import {
  AlternativeProjectEventData,
  renderAlternativeProjectCard,
  clickOnAlternativeProjectCard,
} from 'src/redux/modules/alternativeProjects';

interface StateProps {
  alternativeProjects: {
    items: AlternativeProjectResource[];
  };
  avatars: { [key: string]: string };
}

function mapStateToProps(state: AppState): StateProps {
  return {
    alternativeProjects: state.alternativeProjects,
    avatars: state.avatars.avatars,
  };
}

interface DispatchProps {
  loadAvatars: (userIds: string[]) => void;
  renderAlternativeProjectCard: (data: AlternativeProjectEventData) => void;
  clickOnAlternativeProjectCard: (data: AlternativeProjectEventData) => void;
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return bindActionCreators(
    {
      loadAvatars: loadAvatarImages,
      renderAlternativeProjectCard,
      clickOnAlternativeProjectCard,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AlternativeProjects);



// WEBPACK FOOTER //
// ./src/containers/page/AlternativeProjectsContainer.tsx